import { withWebResponsiveDesign } from 'src/hoc/withWebResponsiveDesign';
import { HeaderDesktopV3 } from './HeaderDesktopV3';
import { THeaderProps } from '../header/Header.types';
import { HeaderMobileV3 } from './HeaderMobileV3';

export const HeaderV3 = withWebResponsiveDesign<THeaderProps>(
  HeaderMobileV3,
  HeaderMobileV3,
  HeaderDesktopV3
);
